import { useQuery } from '@tanstack/react-query';

import type { FeatureFlagService } from '~/shared/feature-flag-service/feature-flag-service';

/** Initializes the feature flag service once per app session. */
export const useFeatureFlagInitialization = (featureFlagService: FeatureFlagService) =>
    useQuery({
        queryFn: () => featureFlagService.initialize(),
        queryKey: ['feature-flags'],
        staleTime: Number.POSITIVE_INFINITY,
        throwOnError: false,
    });
